module.exports = "/assets/data/a303eccc0d275e4603c79e0078e878b4-SG7.data.json";